// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = 23
// module chunks = 0